import { createContext } from 'react';

import type { ModalName, modals } from './modals';

// open modals function based on the modal key as name and component props
type ModalContextType = {
  openModal: <T extends ModalName>(
    name: T,
    props: React.ComponentProps<(typeof modals)[T]>,
  ) => void;
  closeModal: (name: ModalName) => void;
};

export const ModalContext = createContext<ModalContextType | null>(null);
